import { useMutation, useQueryClient } from "@tanstack/react-query";
import { makeApiRequest } from "../../utils";
import { COMMUNITY_REVIEWS_QUERY_KEY } from "../../../constants/queryKeys";

export const useUpdateCommunityReview = () => {
  const queryClient = useQueryClient();

  const updateCommunityReview = useMutation({
    mutationFn: async ({ id, data }) => {
      return makeApiRequest({
        endpoint: `/api/communityReviews/${id}`,
        method: "PUT",
        body: data,
        json: true
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries([COMMUNITY_REVIEWS_QUERY_KEY]);
    }
  });

  return {
    updateCommunityReview
  };
};
